module.exports = __webpack_public_path__ + "static/media/postgresql_logo.3bbbf9a7.png";